import React from "react"

import styled from "styled-components"
import media from "styles/media"
import colors from "styles/colors"
import text from "styles/text"

const Stats = ({ content }) => {
  const allStats = content.map(stat => (
    <StatDiv>
      <Stat>{stat.stat}</Stat>
      <StatCopy>{stat.statCopy}</StatCopy>
      <StatLink href={stat.linkUrl}>{stat.linkText}</StatLink>
    </StatDiv>
  ))
  return <StatsContainer>{allStats}</StatsContainer>
}

const StatLink = styled.a`
  ${text.bodyMdBold};
  color: ${colors.primaryOrange};
`
const StatCopy = styled.p`
  ${text.bodyMd};
  text-align: center;
`
const Stat = styled.p`
  ${text.stat};
  color: ${colors.primaryOrange};
`
const StatDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 24.583vw;
  gap: 1.389vw;

  ${media.fullWidth} {
    width: 354px;
    gap: 20px;
  }

  ${media.tablet} {
    width: 29.297vw;
    gap: 1.953vw;
  }

  ${media.mobile} {
    width: 87.85vw;
    gap: 4.673vw;
  }
`
const StatsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2.847vw;

  ${media.fullWidth} {
    gap: 41px;
  }

  ${media.tablet} {
    gap: 2.734vw;
  }

  ${media.mobile} {
    flex-direction: column;
    gap: 7.477vw;
  }
`
export default Stats
